import React, { ComponentType, lazy, Suspense } from "react";
import { DotLoading } from "antd-mobile";

const Loading = (
  <div style={{ paddingTop: "40%", textAlign: "center" }}>
    <DotLoading color="primary" style={{ marginBottom: "16px" }} />
    <br />
    <span>加载中...</span>
  </div>
);

const loadable = (
  importFunc: () => Promise<{ default: ComponentType<any> }>,
  { fallback = null } = { fallback: Loading }
) => {
  const LazyComponent = lazy(importFunc);

  return (props: any) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default loadable;
